(function () {
  var RATE_CACHE_KEY = 'vw_eur_krw_rate_v1';
  var RATE_API_URL = 'https://api.frankfurter.dev/v1/latest?from=EUR&to=KRW';
  var currentRate = null;

  function todayKey() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function readCachedRate() {
    try {
      var raw = localStorage.getItem(RATE_CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data && data.date === todayKey() && typeof data.rate === 'number') {
        return data.rate;
      }
    } catch (e) {}
    return null;
  }

  function writeCachedRate(rate) {
    try {
      localStorage.setItem(RATE_CACHE_KEY, JSON.stringify({ rate: rate, date: todayKey() }));
    } catch (e) {}
  }

  function applyRate(rate, force) {
    var selector = force
      ? '.price-krw-estimate[data-eur-cents]'
      : '.price-krw-estimate[data-eur-cents]:not([data-krw-filled])';
    var nodes = document.querySelectorAll(selector);
    nodes.forEach(function (node) {
      var cents = parseInt(node.getAttribute('data-eur-cents'), 10);
      if (!cents || isNaN(cents)) return;
      var eur = cents / 100;
      var krw = Math.round((eur * rate) / 10) * 10;
      node.textContent = '≈ ' + krw.toLocaleString('ko-KR') + '원';
      node.setAttribute('data-krw-filled', 'true');
    });
  }

  function handleFetchFailure() {
    // Rate fetch failed: clear placeholder text and hide any dedicated KRW box
    // rather than leaving a stuck "환율 조회 중..." message on screen.
    document.querySelectorAll('.price-krw-estimate[data-eur-cents]:not([data-krw-filled])').forEach(function (node) {
      node.textContent = '';
      var box = node.closest('.vw-krw-estimate-box');
      if (box) box.style.display = 'none';
    });
  }

  function init(rate) {
    currentRate = rate;
    applyRate(currentRate, false);
    var observer = new MutationObserver(function () {
      applyRate(currentRate, false);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    var cached = readCachedRate();
    if (cached) {
      init(cached);
      return;
    }
    fetch(RATE_API_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('rate fetch failed');
        return res.json();
      })
      .then(function (data) {
        var rate = data && data.rates && data.rates.KRW;
        if (typeof rate !== 'number') throw new Error('no rate in response');
        writeCachedRate(rate);
        init(rate);
      })
      .catch(handleFetchFailure);
  }

  function refreshNow(button) {
    button.classList.add('vw-krw-refresh--loading');
    button.disabled = true;
    fetch(RATE_API_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('rate fetch failed');
        return res.json();
      })
      .then(function (data) {
        var rate = data && data.rates && data.rates.KRW;
        if (typeof rate !== 'number') throw new Error('no rate in response');
        writeCachedRate(rate);
        currentRate = rate;
        applyRate(currentRate, true);
      })
      .catch(function () {
        // Keep showing the previous estimate if a manual refresh fails.
      })
      .finally(function () {
        button.classList.remove('vw-krw-refresh--loading');
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-vw-krw-refresh]');
    if (button) refreshNow(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
